import { ApiModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";
import { RecommendationService } from "./recommendation.service";

export const RecommendationModule: Module = {
  name: "RecommendationModule",
  modules: [ApiModule],
  providers: [RecommendationService],
};
